<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="
                $l('dialog_header_purchase_fabric_search') ||
                  '采购单号/面料编号/源头订单号/供方 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
      <el-dialog
        :title="$l('INDEX.advanced_search') || '高级搜索'"
        :show-close="true"
        :visible.sync="advqueryDialogVisible"
        width="750px"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-form ref="form" :model="form" size="small" label-position="top">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_fabricNo') || '物料编码'"
              >
                <el-input v-model.trim="form.fabricNo" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_fabricName') || '物料名称'"
              >
                <el-input v-model.trim="form.fabricName" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_purchaseFabricNo') || '采购单号'"
              >
                <el-input
                  v-model.trim="form.purchaseFabricNo"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="
                  $l('form_label_originOrderNo') || '源头订单号'
                "
              >
                <el-input
                  v-model.trim="form.originOrderNo"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item :label="$l('form_label_scmName') || '供方'">
                <dict-select
                  :placeholder="
                    $l('tips_purchase_form_label_scmCode') ||
                      '请选择大货供应商'
                  "
                  size="small"
                  clearable
                  filterable
                  multiple
                  v-model="form.scmCodeList"
                  url="/master/common/dict/scmPartners"
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_purchaserEntityCode') || '需方'"
              >
                <dict-select
                  v-model="form.purchaserEntityCodeList"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'orderSource' }"
                  :placeholder="
                    $l('tips_purchase_form_label_purchaserEntityCode') ||
                      '请选择需方'
                  "
                  size="small"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_buyerName') || '采购人员'"
              >
                <dict-select
                  multiple
                  clearable
                  v-model="form.buyerCodeList"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_label_please_select_a_buyer') ||
                      '请选择采购人员'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_reviewByName') || '审核人员'"
              >
                <dict-select
                  multiple
                  clearable
                  v-model="form.reviewByList"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_label_please_select_a_review_by') ||
                      '请选择审核人员'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginCreateTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">--</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endCreateTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.table_label_modification_date') || '修改时间'"
              >
                <el-row>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginModifyTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">--</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endModifyTime"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_createBy') || '创建人'"
              >
                <dict-select
                  multiple
                  clearable
                  v-model="form.createByList"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_label_please_select_a_create_by') ||
                      '请选择创建人'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_modifyBy') || '修改人'"
              >
                <dict-select
                  multiple
                  clearable
                  v-model="form.modifyByList"
                  filterable
                  size="small"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_label_please_select_a_modify_by') ||
                      '请选择修改人'
                  "
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeAdvqueryDialog">{{
            $l('INDEX.btn_cancel_query') || '取消查询'
          }}</el-button>
          <el-button size="small" type="warning" @click="reload">{{
            $l('INDEX.btn_reset_filter') || '重置条件'
          }}</el-button>
          <el-button size="small" type="primary" @click="advquery">{{
            $l('INDEX.btn_data_retrieval') || '数据检索'
          }}</el-button>
        </span>
      </el-dialog>
    </b-row>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
  statusList: ['Y'],
}

export default {
  components: {},
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
::v-deep {
  .drop {
    .el-button {
      border: 1px solid #28a745;
      color: #28a745;
      font-size: 0.875rem;
      border-radius: 3px 0px 0px 3px !important;
    }
    .el-dropdown__caret-button {
      border-left: none;
      border-radius: 0px 3px 3px 0px !important;
    }
    .el-button:hover {
      color: #fff;
      background-color: #28a745;
      border-color: #28a745;
    }
    .el-button--default::before {
      background: #d0d2d6;
    }
    .el-button--small {
      padding: 0.25rem 0.5rem;
      font-size: 0.875rem;
      line-height: 1.5;
    }
  }
}
</style>
